import { helper } from '@ember/component/helper';

export default helper(function filterSubjectsWithSummaries([
  subjects,
  learnerSummaries,
]) {
  if (!subjects || !learnerSummaries) {
    return [];
  }
  return subjects.filter((subject) => !!learnerSummaries[subject.get('id')]);
});
